import FrontRow from "./FrontRow";
import AdminRow from "./AdminRow";
import { useEffect } from "react";
import TableLoader from "./TableLoader";
import { fetchComments } from "../../utils/api";

const TableBody = ({
	loading,
	wpUserLoggedIn,
	year,
	categories,
	weekNumbers,
	comments,
	setComments,
	setUpdatedValue,
}) => {
	useEffect(() => {
		// Fetch arena category data from the API on component mount
		const handleFetchComments = () => {
			fetchComments(year, setComments)
				.then((comments) => {
					setComments(comments);
				})
				.catch((error) => {
					// Handle error
				});
		};

		handleFetchComments();
	}, [year]);

	return (
		<>
			<tbody>
				{loading ? (
					<tr>
						<td colSpan={30} className="p-0">
							<TableLoader />
						</td>
					</tr>
				) : (
					comments.map((comment, commentIndex) => {
						return wpUserLoggedIn ? (
							<AdminRow
								key={`admin_${commentIndex}`}
								comment={comment}
								commentIndex={commentIndex}
								weekNumbers={weekNumbers}
								categories={categories}
								year={year}
								setUpdatedValue={setUpdatedValue}
								comments={comments}
								setComments={setComments}
							/>
						) : (
							<FrontRow
								key={`front_${commentIndex}`}
								comment={comment}
								weekNumbers={weekNumbers}
							/>
						);
					})
				)}
			</tbody>
		</>
	);
};

export default TableBody;
